import { IJBPPlanning } from '../../models/IJBPPlanning'
import { OVERALL_CATEGORY } from '../config'

export const getIsCollapsedL3Category = (
  data: IJBPPlanning[],
  fyear: number,
  subCategory: string
) => {
  const filteredData = data.filter(
    (el) =>
      el.FYear === fyear &&
      el.SubCategory === subCategory &&
      el.L3Category === OVERALL_CATEGORY &&
      !!el.IsCollapsed
  )

  return !!filteredData.length
}
